'use strict';

const _=require('pulsar-utils/dist-es6/_');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const UserInfo=require('../../../dist-es6/client/dtos/userInfo');let

OrganizationProfileData=class OrganizationProfileData{
constructor(name,contractStartDate,serviceStartDate,serviceEndDate,primaryUserId,users,dataRetentionPeriodMs,hideAllGroupsByDefault){
_.ensureInstanceOf('string',name);
_.ensureInstanceOf(Date,contractStartDate);
_.ensureInstanceOf(Date,serviceStartDate);
if(_.exists(serviceEndDate))_.ensureInstanceOf(Date,contractStartDate);
_.ensureInstanceOf(Guid,primaryUserId);
_.ensureInstanceOf(Array,users);
users.forEach(user=>_.ensureInstanceOf(UserInfo,user));
_.ensureInstanceOf(['nullable','number'],dataRetentionPeriodMs);
_.ensureInstanceOf('boolean',hideAllGroupsByDefault);

this._name=name;
this._contractStartDate=contractStartDate;
this._serviceStartDate=serviceStartDate;
this._serviceEndDate=serviceEndDate;
this._primaryUserId=primaryUserId;
this._users=users;
this._dataRetentionPeriodMs=dataRetentionPeriodMs;
this._hideAllGroupsByDefault=hideAllGroupsByDefault;
}

get name(){
return this._name;
}

get contractStartDate(){
return this._contractStartDate;
}

get serviceStartDate(){
return this._serviceStartDate;
}

get serviceEndDate(){
return this._serviceEndDate;
}

get primaryUserId(){
return this._primaryUserId;
}

get users(){
return this._users;
}

get dataRetentionPeriodMs(){
return this._dataRetentionPeriodMs;
}

get hideAllGroupsByDefault(){
return this._hideAllGroupsByDefault;
}

toJSON(){
return{
name:this._name,
contractStartDate:this._contractStartDate.toISOString(),
serviceStartDate:this._serviceStartDate.toISOString(),
serviceEndDate:_.exists(this._serviceEndDate)?this._serviceEndDate.toISOString():null,
primaryUserId:this._primaryUserId.toString(),
users:this._users.map(u=>u.toJSON()),
dataRetentionPeriodMs:this._dataRetentionPeriodMs,
hideAllGroupsByDefault:_.exists(this._hideAllGroupsByDefault)?this._hideAllGroupsByDefault:!1};

}

static fromJSON(json){
return new OrganizationProfileData(
json.name,
new Date(json.contractStartDate),
new Date(json.serviceStartDate),
_.exists(json.serviceEndDate)?new Date(json.serviceEndDate):null,
Guid.fromString(json.primaryUserId),
json.users.map(u=>UserInfo.fromJSON(u)),
json.dataRetentionPeriodMs,
_.exists(json.hideAllGroupsByDefault)?json.hideAllGroupsByDefault:!1);

}};


module.exports=OrganizationProfileData;
//# sourceMappingURL=organizationProfileData.js.map
